import { Box, Typography, Chip } from '@mui/material';
import RouterIcon from '@mui/icons-material/Router';
import { InfoCard } from './InfoCard';
import type { Equipment } from '../../context/EquipmentContext';

const DIRECTION_TRANSLATIONS: Record<string, string> = {
  North: 'Norte',
  South: 'Sul',
  East: 'Leste',
  West: 'Oeste',
  Northeast: 'Nordeste',
  Northwest: 'Noroeste',
  Southeast: 'Sudeste',
  Southwest: 'Sudoeste',
};

interface EquipmentInfoProps {
  equipment: Equipment;
}

export function EquipmentInfo({ equipment }: EquipmentInfoProps) {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, background: '#F8FAFF', borderRadius: 3, p: 2 }}>
        <Box sx={{ width: 48, height: 48, borderRadius: '50%', background: '#6366F1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <RouterIcon sx={{ fontSize: 28, color: 'white' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Chip label="Equipamento" color="primary" size="small" variant="outlined" />
            {equipment.tenantName && (
              <Typography color="#6B7280" fontSize={14}>
                {equipment.tenantName}
              </Typography>
            )}
          </Box>
          <Typography variant="h6" fontWeight={700} color="#23272E" mb={0.5}>
            {equipment.name}
          </Typography>
          <Typography color="#6B7280" fontSize={14}>
            Serial: {equipment.serialWiegan} • MAC: {equipment.mac}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 3 }}>
        <InfoCard label="Nome" value={equipment.name} />
        <InfoCard label="Serial Wiegan" value={equipment.serialWiegan} />
        <InfoCard 
          label="Endereço MAC" 
          value={equipment.mac} 
          customValue={
            <Typography component="span" sx={{ fontFamily: 'monospace', backgroundColor: '#E5E7EB', color: '#111827', px: 2, py: 0.5, borderRadius: 2, fontSize: 16, display: 'inline-block', fontWeight: 700 }}>
              {equipment.mac}
            </Typography>
          }
        />
        <InfoCard label="Direção" value={DIRECTION_TRANSLATIONS[equipment.direction] || equipment.direction} />
      </Box>
    </>
  );
} 